/**
 * Work Management Service
 * Work tracking and management service API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AssignmentResponseDto } from './assignmentResponseDto';
import { RelationshipResponseDto } from './relationshipResponseDto';
import { CompletionStatusResponseDto } from './completionStatusResponseDto';
import { WorkItemResponseDto } from './workItemResponseDto';
import { WorkTypeResponseDto } from './workTypeResponseDto';


export interface WorkItemWithRelationshipsResponseDto { 
    /**
     * Work item ID
     */
    id: string;
    /**
     * Tenant ID
     */
    tenantId: string;
    /**
     * Element ID from reference-data-service
     */
    elementId: string;
    /**
     * Patient ID if this work item is related to a specific patient
     */
    patientId?: string;
    /**
     * Work item title
     */
    title: string;
    /**
     * Detailed description
     */
    description?: string;
    /**
     * Rich text content for frontend display
     */
    content?: string;
    /**
     * Current status
     */
    status: WorkItemWithRelationshipsResponseDto.StatusEnum;
    /**
     * Current status reason
     */
    statusReason?: string;
    /**
     * Priority level
     */
    priority: WorkItemWithRelationshipsResponseDto.PriorityEnum;
    /**
     * Current assignment
     */
    assignment?: AssignmentResponseDto;
    /**
     * Custom metadata
     */
    metadata?: any;
    /**
     * Due date
     */
    dueDate?: string;
    /**
     * Parent work item ID
     */
    parentWorkItemId?: string;
    /**
     * Child work item IDs
     */
    childWorkItemIds: Array<string>;
    /**
     * Child work items (only included with expand=children)
     */
    children?: Array<WorkItemResponseDto>;
    /**
     * Completion status for parent work items
     */
    completionStatus?: CompletionStatusResponseDto;
    /**
     * Parent completion rule
     */
    parentCompletionRule?: WorkItemWithRelationshipsResponseDto.ParentCompletionRuleEnum;
    /**
     * Target audience for this work item
     */
    targetAudience: WorkItemWithRelationshipsResponseDto.TargetAudienceEnum;
    /**
     * Created timestamp
     */
    createdOn: string;
    /**
     * Created by user ID
     */
    createdBy: string;
    /**
     * Last modified timestamp
     */
    updatedOn?: string;
    /**
     * Last modified by user ID
     */
    updatedBy?: string;
    /**
     * Work type details with groups (only included with expand=work-type)
     */
    workType?: WorkTypeResponseDto;
    /**
     * Relationships that matched the search criteria
     */
    relationships: Array<RelationshipResponseDto>;
}
export namespace WorkItemWithRelationshipsResponseDto {
    export type StatusEnum = 'open' | 'closed' | 'on-hold';
    export const StatusEnum = {
        Open: 'open' as StatusEnum,
        Closed: 'closed' as StatusEnum,
        OnHold: 'on-hold' as StatusEnum
    };
    export type PriorityEnum = 'low' | 'medium' | 'high' | 'urgent';
    export const PriorityEnum = {
        Low: 'low' as PriorityEnum,
        Medium: 'medium' as PriorityEnum,
        High: 'high' as PriorityEnum,
        Urgent: 'urgent' as PriorityEnum
    };
    export type ParentCompletionRuleEnum = 'all_children_complete' | 'any_child_complete' | 'manual';
    export const ParentCompletionRuleEnum = {
        AllChildrenComplete: 'all_children_complete' as ParentCompletionRuleEnum,
        AnyChildComplete: 'any_child_complete' as ParentCompletionRuleEnum,
        Manual: 'manual' as ParentCompletionRuleEnum
    };
    export type TargetAudienceEnum = 'provider' | 'patient';
    export const TargetAudienceEnum = {
        Provider: 'provider' as TargetAudienceEnum,
        Patient: 'patient' as TargetAudienceEnum
    };
}


